/** Audiencia — sincronizado con enum gfi_resource_audience */
export const RESOURCE_AUDIENCES = [
  { value: 'cliente', label: 'Cliente' },
  { value: 'interno', label: 'Interno' },
];

/** Tipo de enlace externo — sincronizado con enum gfi_resource_link_kind */
export const RESOURCE_LINK_KINDS = [
  { value: 'video', label: 'Video' },
  { value: 'canva', label: 'Canva' },
  { value: 'google_slides', label: 'Google Slides' },
  { value: 'google_sheets', label: 'Google Sheets' },
  { value: 'google_docs', label: 'Google Docs' },
];

export const RESOURCE_FILE_ACCEPT = '.pdf,.docx,.md,.markdown,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/markdown';
